/* eslint-disable import/no-unresolved */
import React from 'react';
import { Link } from 'gatsby';
import { IoIosArrowRoundForward } from 'react-icons/io';
import ResultsLogoSwiper from '../ResultsLogoSwiper';

const AboutUsCustomers = () => {
  return (
    <div className="container">
      <div className="key-results">
        <div className="item head">
          <div className="element">
            <h3>Our team is incomplete without you, our customers</h3>
            <Link to="/case-studies/" className="read-more">
              Go to case studies <IoIosArrowRoundForward />
            </Link>
          </div>
        </div>
        <div className="item">
          <ResultsLogoSwiper
            slidesToShow={4}
            responsive={[
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 3
                }
              },
              {
                breakpoint: 460,
                settings: {
                  slidesToShow: 2
                }
              }
            ]}
          />
        </div>
      </div>
    </div>
  );
};

export default AboutUsCustomers;
